module.exports = __webpack_public_path__ + "img/line2.a933cdaf.svg";